import { ethers } from 'ethers';
/**
 * The use-case arose from Gnosis Safe transaction serialization failing.
 */
export const trySerializeTransaction = (transaction, signature) => {
    try {
        return ethers.utils.serializeTransaction(transaction, signature);
    }
    catch (error) {
        // This tends to happen with Gnosis Safe which changes the transaction response structure.
        console.warn(error);
    }
    return undefined;
};
//# sourceMappingURL=trySerializeTransaction.js.map